export default [
  {
    path: "/usuarios",
    component: () =>
      import(/* webpackChunkName: "usuarios" */ "../views/Usuarios.vue"),
    meta: {
      requiresAuth: true,
    },
    // children: [
    //   {
    //     path: "",
    //     component: () =>
    //       import(
    //         /* webpackChunkName: "contratos-termos-adesao" */
    //         "../components/contratos/ContratoTermosAdesao.vue"
    //       ),
    //   },
      
    // ],
  },
];
